import script from "./SelectMoveAssignee.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectMoveAssignee.vue?vue&type=script&setup=true&lang=js"

import "./SelectMoveAssignee.vue?vue&type=style&index=0&id=122517ab&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-122517ab"]])

export default __exports__